import { parseUtcDateTime } from "../../helpers/utc-date";

export const formatChecklistTimestamp = (value) => {
  if (!value) return "";
  const timestamp = parseUtcDateTime(value);
  const day = timestamp.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  const time = timestamp.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", second: "2-digit", hour12: true });
  return `${day}, ${time}`;
  };
